<template>
  <div class="fill-height">
    <v-container grid-list-xs class="d-flex justify-center">
      <div v-if="hasCards === 'yes'" class="card-container">
        <v-container
          grid-list-xs
          class="d-flex flex-column justify-center align-center py-16"
        >
          <v-card class="card-radius card-shadow card-width" elevation="0">
            <v-card-title
              primary-title
              class="accentDarkBlue white--text title font-weight-medium px-10"
              >Cetak Data</v-card-title
            >

            <v-container grid-list-xs class="py-5">
              <v-col v-for="info in cards" :key="info.url">
                <v-card
                  class="card-radius card-shadow py-3 px-8"
                  elevation="0"
                  :href="`https://dev-api-ppdb.smkruskudus.com/preview/${id}?type=${info.urlBad}`"
                >
                  <v-row align="center">
                    <div
                      class="
                        icon-radius
                        pa-3
                        pink-color
                        mr-5
                        hidden-sm-and-down
                      "
                    >
                      <v-icon size="40">{{ info.icon }}</v-icon>
                    </div>
                    <div class="card-text font-weight-medium">
                      {{ info.text }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-row>
                </v-card>
              </v-col>
            </v-container>
          </v-card>
        </v-container>
      </div>

      <div class="card-wrapper" v-if="hasCards === 'no'">
        <v-card class="py-5">
          <v-container grid-list-xs py5>
            <center>
              <p>Anda tidak memiliki data untuk dicetak.</p>
            </center>
          </v-container>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    hasCards: "",
    status: "",
    cards: [
      {
        text: "Cetakan Formulir Pendaftaran",
        url: "formulir",
        urlBad: "PENDAFTARAN",
        icon: "mdi-printer",
      },
      {
        text: "Kartu Test",
        url: "kartu-test",
        urlBad: "TEST",
        icon: "mdi-printer",
      },
    ],
    id: "",
  }),
  mounted() {
    this.getCard();
  },
  methods: {
    async getCard() {
      EventBus.$emit("startLoading");

      this.id = localStorage.getItem("id");

      const resCard = await axios.get(`${this.$api}/cek-kartu?id=${this.id}`);
      const res = resCard.data;

      if (
        (res.STATUS === "SUCCESS" && res.MESSAGE === "Berhasil") ||
        (res.STATUS === "SUCCESS" && res.MESSAGE === "exam result unavailabe!")
      ) {
        this.hasCards = "yes";
      } else {
        this.hasCards = "no";
      }

      EventBus.$emit("stopLoading");
    },
  },
};
</script>

<style scoped>
.print-section {
  min-height: 80vh;
}

.card-width {
  width: 40rem;
}

.card-container {
  width: 100%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.pink-color {
  background-color: #fec0a0;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.icon-radius {
  border-radius: 7px !important;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.inbox-card {
  border-left: 8px solid #2a429e;
}

.a-link {
  text-decoration: none;
  color: #2a429e;
}

.a-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 90%;
  }

  .card-text {
    font-size: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .card-wrapper {
    width: 80%;
  }
}
</style>
